export function updateDamages(roundData, currentTick, previousTick, getConvertedCords, pixelsPerMapUnit, existingDamages = []) {
  if (!roundData || !roundData.damages) return [];

  const now = Date.now();
  const activeDamages = [];
  const processedDamageIds = new Set();
  const ppu = pixelsPerMapUnit || 1;

  const DAMAGE_RISE_U = 25;
  const DAMAGE_RANDOM_OFFSET_U = 10;
  const DAMAGE_FONT_U = 12;

  // Keep existing damages that are still animating
  existingDamages.forEach((damage) => {
    const elapsed = now - damage.startTime;
    if (elapsed < damage.duration) {
      // Still animating, update position
      const progress = elapsed / damage.duration;
      const yOffset = -DAMAGE_RISE_U * progress * ppu; // Move upward (half the height)
      const opacity = 0.6 * (1 - progress); // Fade out

      activeDamages.push({
        ...damage,
        y: damage.initialY + yOffset,
        opacity: Math.max(0, opacity),
      });
      processedDamageIds.add(damage.id);
    }
  });

  // Find new damages that occurred between previousTick and currentTick
  const newDamages = roundData.damages.filter(
    (damage) => damage.tick > previousTick && damage.tick <= currentTick,
  );

  newDamages.forEach((damage) => {
    if (processedDamageIds.has(`damage-${damage.tick}-${damage.victimSteamID}`)) {
      return; // Already processing this damage
    }

    const cords = getConvertedCords(damage.victimX, damage.victimY);
    if (!cords) return;

    // Random offset for visual variety
    const randomXOffset = (Math.random() * DAMAGE_RANDOM_OFFSET_U - (DAMAGE_RANDOM_OFFSET_U / 2)) * ppu;
    const randomYOffset = (Math.random() * DAMAGE_RANDOM_OFFSET_U - (DAMAGE_RANDOM_OFFSET_U / 2)) * ppu;

    const fontSize = DAMAGE_FONT_U * ppu; // Smaller font size
    const duration = 300; // 0.3 seconds animation (twice as fast)

    activeDamages.push({
      id: `damage-${damage.tick}-${damage.victimSteamID}`,
      amount: damage.hpDamage,
      x: cords.x + randomXOffset,
      y: cords.y + randomYOffset,
      initialY: cords.y + randomYOffset,
      opacity: 0.6,
      fontSize,
      startTime: now,
      duration,
    });
  });

  return activeDamages;
}
